import * as moment from 'moment';

const padding = 8; // 4 pixels on either side


export function measureTimelineLabelWidth() {
    let maxWidth = 0;
    
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d') as CanvasRenderingContext2D;
    context.font = '11px sans-serif'; // Same font and size as used in TimelineView.tsx

    // Calculate the width of a hypothetical time label at every minute of the day
    const date = moment(new Date().setHours(0, 0, 0, 0));
    for (let i = 0; i < 1440; i++) {
        const { width } = context.measureText(date.format('LT')); // Same time format as used in TimelineView.tsx
        if (width > maxWidth) {
            maxWidth = width;
        }
        date.add(1, 'minute');
    }

    return Math.ceil(maxWidth) + padding;
}


// WEBPACK FOOTER //
// ./src/startup/measureTimelineLabelWidth.ts